import { defineComponent } from 'vue';
import RightsSearch from '@/presentation/components/rights/rights-search/search-input.vue';
import RightsUsersOverview from '@/presentation/components/rights/rights-users-overview/rights-user-overview.vue';
import LoadingWrapper from '@/presentation/components/shared/loading-wrapper/loading-wrapper.vue';
import RightsUsersCode from '@/presentation/components/rights/rights-users.code';

export default defineComponent({
	components: {
		LoadingWrapper,
		RightsSearch,
		RightsUsersOverview
	},
	setup: () => {
		const code = new RightsUsersCode();

		return {
			isLoading: code.isLoading
		};
	}
});
